import React, {ComponentProps, FC, useCallback} from 'react'

import {useSubscriptionBooking} from '../../../api/subscription-bookings/hooks'
import {SubscriptionActivity} from '../../../api/subscriptions/types'
import {useServiceOptions} from '../../../services/service-options/hooks'
import {EntityCard} from '../../../ui/components/entity-card/entity-card'
import {useLocale} from '../../../utils/i18n'
import {useModalActions} from '../../../utils/modals'
import {BenefitFeatures} from './benefit-features'
import {SubscriptionBenefitsModal} from './modals/subscription-benefits-modal'
import {BenefitProps} from './types'

const benefitGroupTypeToEntityCardTypeMap: {[key in SubscriptionActivity['groupType']]: ComponentProps<typeof EntityCard>['styleType']} = {
  all: 'class',
  class: 'class',
  service: 'service',
  teacher: 'service'
}

export const BenefitTitle: FC<BenefitProps> = ({
  benefit,
}) => {
  const {l} = useLocale()
  const {openModal} = useModalActions()
  const firstEntity = benefit.entities[0]
  const {data: subscriptionBooking} = useSubscriptionBooking()
  const {getServiceConfigByServiceType, isLoading: isServiceOptionsLoading} = useServiceOptions()
  const isAllClasses = firstEntity.sportType === 'ALL_CLASSES'
  const name = benefit.entities.length > 1
    ? `${firstEntity.name} +${benefit.entities.length - 1} ${l('other')}`
    : firstEntity.name

  const handleOpenSubscriptionBenefitsList = useCallback(() => {
    openModal({
      component: <SubscriptionBenefitsModal benefit={benefit} subscriptionBooking={subscriptionBooking}/>,
      footerConfig: {disabled: true},
      title: l('benefits'),
    })
  }, [openModal, benefit, l])

  if (isAllClasses) {
    return (
      <EntityCard
        text={name}
        styleType={'class'}
        icon={getServiceConfigByServiceType('ALL_CLASSES').icon}
        subText={<BenefitFeatures benefit={benefit} />}
        onClick={handleOpenSubscriptionBenefitsList}
      />
    )
  }

  const styleType = !firstEntity.areaSpace
    ? benefitGroupTypeToEntityCardTypeMap[benefit.groupType]
    : 'justTheSpace'

  return (
    <EntityCard
      text={name}
      styleType={styleType}
      isLoading={isServiceOptionsLoading}
      onClick={handleOpenSubscriptionBenefitsList}
      icon={getServiceConfigByServiceType(firstEntity.sportType).icon}
      subText={<BenefitFeatures benefit={benefit} />}
    />
  )

  /* return (
    <Box
      py={'8'}
      flex={1}
      alignItems='center'
      flexDirection={'row'}
    >
      {
        (isAllClasses || !firstEntity?.name)
          ? (
            <Box
              backgroundColor={'grayShade'}
              borderRadius={12}
              overflow='hidden'
            >
              <Box
                width={48}
                height={48}
                bg={'orange01'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <SubscriptionsTabIcon color={'orange'}/>
              </Box>
            </Box>
          )
          : (
            <Box position={'relative'}>
              <SportTypeIcon
                isClass={true}
                areaSpace={false}
                sportType={firstEntity.sportType}
              />
              {
                entitiesLength > 1
                && (
                  <BoxWithText text={`+${entitiesLength - 1}`} />
                )
              }
            </Box>
          )
      }
      <Box ml={'12'} flex={1} alignItems='flex-start'>
        <P
          mb={'2'}
          variant={'h3'}
        >
          {
            isAllClasses
              ? l('allClasses')
              : firstEntity.isAll ? l('all') : name
          }
          {
            firstEntity.isAll
            && (
              /!* <SportTypeLabel
                sportType={firstEntity.sportType}
                styleSettings={{
                  numberOfLines: 1,
                  variant: 'h3',
                }}
              />*!/
              firstEntity.sportType
            )
          }
        </P>
        {
          !withoutSubText
          && <UsageAllowance benefit={benefit} withUsage={withUsage} />
        }
      </Box>
    </Box>
  )*/
}